<section class="dealerPortalContainer">
    <h2 class="title">Welcome to the Dealer Portal</h2>
    <!-- Chargers -->
    <app-ng-accordion [title]="'Quantum Charger'" widgetId="dp_quantum_charger" headerClass="dealerPortalStyle">
		<h3>Troubleshooting</h3>
        <div *ngFor="let group of documentPath['TroubleShooting-Chargers'].files">
            <p class="download-link" (click)="downloadDocument(group[1] || '')">{{group[0]}}</p>
        </div>

        <h3>Programming & Replacement</h3>
        <div *ngFor="let group of documentPath['Programming&Replacement-Chargers'].files">
            <p class="download-link" (click)="downloadDocument(group[1] || '')">{{group[0]}}</p>
        </div>

        <h3>Technical Specifications</h3>
        <div *ngFor="let group of documentPath['Technical-Specifications-Chargers'].files">
            <p class="download-link" (click)="downloadDocument(group[1] || '')">{{group[0]}}</p>
        </div>

        <h3>Manuals</h3>
        <div *ngFor="let group of documentPath['Manuals-Chargers'].files">
            <p class="download-link" (click)="downloadDocument(group[1] || '')">{{group[0]}}</p>
        </div>
    </app-ng-accordion>

    <!-- Battview -->
    <app-ng-accordion [title]="'BATTview Monitor'" widgetId="dp_battview_monitor" headerClass="dealerPortalStyle">
		<h3>Troubleshooting</h3>
        <div *ngFor="let group of documentPath['TroubleShooting-Battview'].files">
            <p class="download-link" (click)="downloadDocument(group[1] || '')">{{group[0]}}</p>
        </div>

        <h3>Programming & Replacement</h3>
        <div *ngFor="let group of documentPath['Programming&Replacement-Battview'].files">
            <p class="download-link" (click)="downloadDocument(group[1] || '')">{{group[0]}}</p>
        </div>

        <h3>Technical Specifications</h3>
        <div *ngFor="let group of documentPath['Technical-Specifications-Battview'].files">
            <p class="download-link" (click)="downloadDocument(group[1] || '')">{{group[0]}}</p>
        </div>

        <h3>Manuals</h3>
        <div *ngFor="let group of documentPath['Manuals-Battview'].files">
            <p class="download-link" (click)="downloadDocument(group[1] || '')">{{group[0]}}</p>
        </div>
    </app-ng-accordion>

    <!-- ACTlink -->
     <app-ng-accordion [title]="'ACTlink'" widgetId="dp_actlink" headerClass="dealerPortalStyle">
        <div *ngFor="let group of documentPath['ACTlink'].files">
            <p class="download-link" (click)="downloadDocument(group[1] || '')">{{group[0]}}</p>
        </div>
    </app-ng-accordion>

    <!-- ACTview -->
     <app-ng-accordion [title]="'ACTview'" widgetId="dp_actview" headerClass="dealerPortalStyle">
        <div *ngFor="let group of documentPath['ACTview'].files">
            <p class="download-link" (click)="downloadDocument(group[1] || '')">{{group[0]}}</p>
        </div>
    </app-ng-accordion>
     <!-- Polarlink -->
     <app-ng-accordion [title]="'Polarlink'" widgetId="dp_polarlink" headerClass="dealerPortalStyle">
        <div *ngFor="let group of documentPath['Polarlink'].files">
            <p class="download-link" (click)="downloadDocument(group[1] || '')">{{group[0]}}</p>
        </div>
    </app-ng-accordion>

    <!-- Service Bulletins -->
     <!-- <app-ng-accordion [title]="'Service Bulletins'" widgetId="dp_service_bulletins" headerClass="dealerPortalStyle">
        <div *ngFor="let group of documentPath['Service-Bulletins'].files">
            <p class="download-link" (click)="downloadDocument(group[1] || '')">{{group[0]}}</p>
        </div>
    </app-ng-accordion> -->

</section>